<template>
    <div>
        <b-form-file v-if="!importExcelFile" v-model="importExcelFile" accept=".xlsx" size="sm"
            @change="importScoreExcel" placeholder="Choose an Excel file or drop it here..."
            drop-placeholder="Drop file here...">
        </b-form-file>
        <span v-if="importExcelFile" class="text-danger">{{ excelImportStatus }}</span>

        <div>
            <p style="font-size: 14px; font-weight: 600">Seminar Scores</p>
            <h6 style="font-size: 14px; font-weight: 900">Note:</h6>
            <p><strong>1) Please do not include headings in the spreadsheet used to import data. Enter only the
                    values.</strong></p>
            <p style="color: red; font-weight: bold;">
                2) The column containing Total Marks (the total of method parameters) should either be blank or contain
                a value.
                Irrespective of this, the total marks will be calculated automatically.
            </p>
            <br>

            <img src="@/assets/images/seminarscore.png" alt="Lab Score" class="img-fluid mx-auto d-block"
                loading="lazy" />
            <br>
            <p>The imported data will look like this</p>
            <img src="@/assets/images/seminarscoreimportoutput.png" alt="Imported Data Output"
                class="img-fluid mx-auto d-block" loading="lazy" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        importExcelFile: {
            type: [File, null],
            default: null
        },
        excelImportStatus: {
            type: String,
            default: ''
        }
    },
    methods: {
        importScoreExcel(event) {
            this.$emit('import', event);
        }
    }
};
</script>
